module.exports = __webpack_public_path__ + "img/ufo-standard.3ed7568a.png";